import React, { Component } from "react";
import axios from "axios";
import { API_URL } from "src/scenes/App";
import {
    FormField, Toast, PageContainer,
    BusinessPortalHeader,
    PAYMENT_FLOW_MAX_WIDTH,
    PortalActionBar,
    PortalCaption,
    PortalIconActionButton,
    PortalFormActions,
    PortalFormScrollBody,
    PortalFormSection,
    PortalFormSectionDescription,
    PortalFormSectionHeader,
    PortalFormSectionTitle,
    PortalFormSurface,
    PortalMetricCard,
    PortalMetricLabel,
    PortalPanelHeader,
    PortalSectionTitle,
    PortalSurface,
    StandardModalActionButton,
    StandardModalActionGroup
} from "src/components";

/* Payment Confirmation */
import PaymentConfirmation from "./PaymentConfirmation.jsx";
import styled from "styled-components";
import { ClientLicenseContext as SubscriptionContext } from "./../ClientLicenseContext";
import GreenCheck from "src/img/new/green-check.svg";
import MailIcon from "src/img/new/mail.svg";
import LicenseIconAsset from "src/img/new/license.svg";

export const FormStep = {
    PAGE_PURCHASE_LICENSE: 1,
    PAGE_PAYMENT_CONFIRMATION: 2,
    PAGE_PURCHASE_SUCCESSFUL: 3
};

/* Payment Confirmation */
const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    flex-grow: 1;
`;

// payment success
const CheckIcon = styled.img`
    width: 2.5625rem;
    height: 2.5625rem;
`;

const MailImage = styled.img`
    width: 1.9375rem;
    height: 1.375rem;
    object-fit: contain;
`;

const FieldWrap = styled.div`
    width: 100%;
    max-width: 17rem;
`;

const LicenseNoteCard = styled(PortalMetricCard)`
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    align-content: center;
    gap: 0.9rem;
    min-height: auto;
`;

const LicenseIconImage = styled.img`
    width: 2.25rem;
    height: 2.25rem;
    object-fit: contain;
`;

const SuccessCard = styled(PortalSurface)`
    width: 100%;
    max-width: ${PAYMENT_FLOW_MAX_WIDTH};
    margin-top: 1.125rem;
    padding: 2rem;

    @media (max-width: 640px) {
        padding: 1rem;
    }
`;

const SuccessTitle = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
`;

const SuccessDetailGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.85rem;
    margin-bottom: 1.25rem;

    @media (max-width: 640px) {
        grid-template-columns: 1fr;
    }
`;

const SuccessDetailCard = styled(PortalMetricCard)`
    min-height: auto;
    align-content: start;
    gap: 0.4rem;
`;

const ReceiptCard = styled(PortalMetricCard)`
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    align-content: center;
    min-height: auto;
    margin-bottom: 1.5rem;
`;

export const PurchaseFlowPage = styled(PageContainer)`
    height: calc(100vh - 64px);
    height: calc(100dvh - 64px);
    min-height: 0;
    overflow: hidden;
    padding-bottom: 2rem;
`;

export const PurchaseFlowSurface = styled(PortalFormSurface)`
    flex: 1 1 auto;
    min-height: 0;
    max-height: none;
`;

export const PurchaseFlowBody = styled(PortalFormScrollBody)`
    min-height: 0;
`;

class PurchaseLicense extends Component {
    state = {
        //global
        purchaseStep: FormStep.PAGE_PURCHASE_LICENSE,
        loadingStatus: false, //who's loading

        //pricing
        licenseCount: 1, 
        shortTermCost: 0.00,
        subtotal: 0.00,
        gst: 0.00,
        processingFee: 0.00,
        currency: null,
        total: 0.00,
        getLicenseCostFromAmountLoading: true,
    };

    nextStep = (stepNumber) => {
        this.setState({ 
            purchaseStep: stepNumber
        });
    };

    updateAmountOfLicense = (event) => {
        const amountOfLicense = Math.max(event.target.value, 1);

        return this.setState({
            licenseCount: amountOfLicense
        });
    };

    getLicenseCostFromAmount = () => {
        this.setState({ 
            getLicenseCostFromAmountLoading: true
        });
        
        const { licenseCount } = this.state;

        axios.get(`${API_URL}/company/licenseCost/${licenseCount}`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            this.setState({
                licenseCount: parseInt(res.data.licenseCount),
                shortTermCost: parseFloat(res.data.shortTermCost),
                subtotal: parseFloat(res.data.subtotal),
                gst: parseFloat(res.data.gst),
                processingFee: parseFloat(res.data.processingFee),
                currency: res.data.currency,
                total: parseFloat(res.data.total)
            });
        }).catch(error => {
            return Toast.error(error.getApiErrorDetails().message);
        }).finally(res => {
            this.setState({ 
                getLicenseCostFromAmountLoading: false
            });
        });
    };

    /**
     *  Returns a Promise that is being used to `await` in CardList.js thisPurchaseClicked()
    */
    payUsingExistingCard = (selectedMethod, methodSource) => {
        if (methodSource === "square") {
            return this.purchaseWithOurApi(
                `${API_URL}/company/square/moreLicenses`,
                {
                    licenseCount: this.state.licenseCount,
                    cardId: selectedMethod
                });
        } else if (methodSource === "airwallex") {
            return this.purchaseWithOurApi(
                `${API_URL}/company/airwallex/purchaseNow/clientLicenses`,
                {
                    licenseCount: this.state.licenseCount,
                    paymentMethodId: selectedMethod
                });
        } else {
            console.log(`Bad method source: ${methodSource}`);
        }
    };

    payUsingAirwallexPaymentMethod = async (selectedMethod) => {
    };

    purchaseWithOurApi = async (url, requestBody) => {
        this.setState({
            purchaseLicenseLoading: true
        });
        
        return axios.post(url, requestBody, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            this.setState({
                purchaseStep: FormStep.PAGE_PURCHASE_SUCCESSFUL,
                purchaseLicenseLoading: false,
            });
        }).catch(error => {
            this.setState({
                purchaseLicenseLoading: false
            });
            return Toast.error(error.getApiErrorDetails().message);
        });
    };

    render() {
        const { user, showPurchaseLicense, getCompanyClientLicense } = this.props;
        const { purchaseStep, licenseCount, shortTermCost, subtotal, gst, processingFee, currency, total, getLicenseCostFromAmountLoading } = this.state;

        const { companyName, countryCode, abn } = user;
        const disableNext = false;


        if (purchaseStep === FormStep.PAGE_PURCHASE_SUCCESSFUL)
            return (
                <PageCongratulations
                    getCompanyClientLicense={getCompanyClientLicense}
                    showPurchaseLicense={showPurchaseLicense}
                    companyName={companyName}
                    licenseCount={licenseCount}
                    nextStep={this.nextStep} />
            );

        return (
            <>
                { purchaseStep === FormStep.PAGE_PURCHASE_LICENSE &&
                <PageLicenseAmount
                    nextStep={this.nextStep}
                    updateAmountOfLicense={this.updateAmountOfLicense}
                    showPurchaseLicense={showPurchaseLicense}
                    licenseCount={licenseCount}
                    disableNext={disableNext}
                />
                }
                { purchaseStep === FormStep.PAGE_PAYMENT_CONFIRMATION &&
                <Container>
                    <SubscriptionContext.Provider value={{
                        //global
                        token: this.props.user.token,
                        nextStep: this.nextStep,
                        companyName: companyName,
                        abn: abn,
                        countryCode: countryCode,
                        currency: currency,
                        //license price related
                        getLicenseCostFromAmount: this.getLicenseCostFromAmount,
                        licenseCount: licenseCount,
                        shortTermCost: shortTermCost,
                        subtotal: subtotal,
                        gst: gst,
                        processingFee: processingFee,
                        total: total,
                        getLicenseCostFromAmountLoading: getLicenseCostFromAmountLoading,

                        //paymentConfirmation card related
                        payUsingExistingCard: this.payUsingExistingCard
                    }}>
                        <PaymentConfirmation />
                    </SubscriptionContext.Provider>
                </Container>
                }
            </>
        );
    }
}

class PageLicenseAmount extends Component {
    render() {
        const { nextStep, updateAmountOfLicense, showPurchaseLicense, licenseCount, disableNext } = this.props;

        return (
            <PurchaseFlowPage>
                <BusinessPortalHeader
                    title="Purchase Trial Licenses"
                    description="Purchase short-term Client Trial Licenses right here. These licenses allow you to invite clients to experience your services for a limited duration, giving them a taste of what your business has to offer before committing to a long-term license."
                    maxWidth={PAYMENT_FLOW_MAX_WIDTH}
                />
                <PurchaseFlowSurface maxWidth={PAYMENT_FLOW_MAX_WIDTH} marginTop="0" flex="1 1 auto" minHeight="0">
                    <PurchaseFlowBody columns="repeat(2, minmax(0, 1fr))" padding="1.25rem" gap="1rem">
                        <PortalFormSection>
                            <PortalFormSectionHeader withDivider>
                                <PortalFormSectionTitle>Enter Amount of User Licenses Required</PortalFormSectionTitle>
                                <PortalFormSectionDescription>
                                    Enter the amount of trial licenses required. Minimum purchase of 1 license is required.
                                </PortalFormSectionDescription>
                            </PortalFormSectionHeader>
                            <FieldWrap>
                                <FormField
                                    margin="0"
                                    height="3.125rem"
                                    borderRadius="var(--calendar-radius-input, 8px)"
                                    size="1.5625rem"
                                    fontWeight="700"
                                    placeholderWeight="700"
                                    placeholderSize="1.5625rem"
                                    onChange={(event) => {updateAmountOfLicense(event);} }
                                    maxLength="4"
                                    value={licenseCount}
                                    type="number"
                                    min="1"
                                />
                            </FieldWrap>
                        </PortalFormSection>
                        <PortalFormSection>
                            <PortalFormSectionHeader withDivider>
                                <PortalFormSectionTitle>License Details</PortalFormSectionTitle>
                                <PortalFormSectionDescription>
                                    These short-term licenses are added to Sales & Promotions after payment.
                                </PortalFormSectionDescription>
                            </PortalFormSectionHeader>
                            <PortalMetricCard minHeight="auto" padding="0.85rem">
                                <PortalMetricLabel>Trial Licenses</PortalMetricLabel>
                                <PortalSectionTitle size="1rem">
                                    {parseInt(licenseCount).toLocaleString("en-us")}
                                </PortalSectionTitle>
                            </PortalMetricCard>

                            <LicenseNoteCard minHeight="auto" padding="0.85rem">
                                <LicenseIconImage src={LicenseIconAsset} alt="" />
                                <div>
                                    <PortalSectionTitle size="0.95rem">Sales & Promotions Licenses</PortalSectionTitle>
                                    <PortalCaption margin="0.25rem 0 0">
                                        Purchased licenses will be added to your business Sales & Promotions feature after payment.
                                    </PortalCaption>
                                </div>
                            </LicenseNoteCard>
                        </PortalFormSection>
                    </PurchaseFlowBody>
                    <PortalFormActions sticky={false}>
                        <StandardModalActionGroup $pushRight>
                            <StandardModalActionButton type="button" onClick={() => showPurchaseLicense(false)}>
                                Back
                            </StandardModalActionButton>
                            <StandardModalActionButton
                                type="button"
                                $variant="primary"
                                onClick={() => nextStep(FormStep.PAGE_PAYMENT_CONFIRMATION)}
                                disabled={disableNext}
                            >
                                Next
                            </StandardModalActionButton>
                        </StandardModalActionGroup>
                    </PortalFormActions>
                </PurchaseFlowSurface>
            </PurchaseFlowPage>
        );
    }
}

class PageCongratulations extends Component {
    hideFormAndReloadList = () => {
        const { showPurchaseLicense, getCompanyClientLicense } = this.props;

        showPurchaseLicense(false);
        getCompanyClientLicense(); 
    };

    render() {
        const { companyName, licenseCount } = this.props;

        return (
            <PageContainer>
                <BusinessPortalHeader
                    title="Your Have Purchased Trial Licenses"
                    description="Congratulations! You have Trial Licenses to invite clients to your Me Business app!"
                    maxWidth={PAYMENT_FLOW_MAX_WIDTH}
                />
                <SuccessCard>
                    <PortalPanelHeader withDivider>
                        <SuccessTitle>
                            <CheckIcon src={GreenCheck} />
                            <PortalSectionTitle size="1.25rem">Purchase Successful!</PortalSectionTitle>
                        </SuccessTitle>
                    </PortalPanelHeader>

                    <SuccessDetailGrid>
                        <SuccessDetailCard>
                            <PortalMetricLabel>Business Name</PortalMetricLabel>
                            <PortalSectionTitle size="1rem">{ companyName }</PortalSectionTitle>
                        </SuccessDetailCard>

                        <SuccessDetailCard>
                            <PortalMetricLabel>Trial Licenses Purchased</PortalMetricLabel>
                            <PortalSectionTitle size="1rem">{ licenseCount }</PortalSectionTitle>
                        </SuccessDetailCard>
                    </SuccessDetailGrid>

                    <ReceiptCard>
                        <MailImage src={MailIcon} />
                        <PortalCaption margin="0" maxWidth="26.9375rem">
                            We sent a copy of your purchase receipt to your email inbox. Please check your email to access your receipt and keep it handy for your records.
                        </PortalCaption>
                    </ReceiptCard>

                    <PortalActionBar
                        justifyContent="flex-start"
                        padding="1.5rem 0 0"
                        border="transparent"
                        shadow="none"
                        radius="0"
                    >
                        <PortalIconActionButton
                            type="button"
                            width="13.5rem"
                            onClick={() => this.hideFormAndReloadList()}
                        >
                            Go to Sales & Promotions
                        </PortalIconActionButton>
                    </PortalActionBar>
                </SuccessCard>
                
            </PageContainer>
        );
    }
}

export default PurchaseLicense;
